import { useState, useEffect } from "react";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
const VendorBankDetails = ({ vendorProfileId, onComplete }) => {
  const { user } = useAuthContext();

  const { documents: organisations } = useCollection("organisations");
  const vendorOrganisations = organisations?.find(
    (org) => org.organisationId === user?.organisationId
  );

  const { updateDocument } = useFirestore("organisations");

  const [isEditing, setIsEditing] = useState(false);
  const [isBankDetailSaving, setIsBankDetailSaving] = useState(false);
  const [saveBankDetailMessage, setSaveBankDetailMessage] = useState("");
  const [BankDetailMessageType, setBankDetailMessageType] = useState("");

  const [bankDetailFormData, setBankDetailFormData] = useState({
    acHolderName: "",
    acNumber: "",
    bankName: "",
    branchName: "",
    ifscCode: "",
    upiId: "",
    qrCode: null,
  });

  // Update BankDetailFormData when vendorOrganisations changes
  useEffect(() => {
    if (vendorOrganisations) {
      setBankDetailFormData({
        acHolderName: vendorOrganisations.bankDetail?.acHolderName || "",
        acNumber: vendorOrganisations.bankDetail?.acNumber || "",
        bankName: vendorOrganisations.bankDetail?.bankName || "",
        branchName: vendorOrganisations.bankDetail?.branchName || "",
        ifscCode: vendorOrganisations.bankDetail?.ifscCode || "",
        upiId: vendorOrganisations.bankDetail?.upiId || "",
        qrCode: vendorOrganisations.bankDetail?.qrCode || null,
      });
    }
  }, [vendorOrganisations]);
  useEffect(() => {
    // Check if all fields are filled
    const allFilled = Object.values(bankDetailFormData).every((v) => v !== "");
    onComplete?.(allFilled);
  }, [bankDetailFormData]);

  const handleBankDetailCancelClick = () => {
    if (vendorOrganisations) {
      setBankDetailFormData({
        acHolderName: vendorOrganisations.bankDetail?.acHolderName || "",
        acNumber: vendorOrganisations.bankDetail?.acNumber || "",
        bankName: vendorOrganisations.bankDetail?.bankName || "",
        branchName: vendorOrganisations.bankDetail?.branchName || "",
        ifscCode: vendorOrganisations.bankDetail?.ifscCode || "",
        upiId: vendorOrganisations.bankDetail?.upiId || "",
        qrCode: vendorOrganisations.bankDetail?.qrCode || null,
      });
    }
    setIsEditing(!isEditing);
  };

  // Handle Input Changes
  const handleBankDetailChange = (e) => {
    const { name, value } = e.target;
    setBankDetailFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Validate Fields
  const validateBankDetailForm = () => {
    if (
      !bankDetailFormData.acHolderName ||
      !bankDetailFormData.acNumber ||
      !bankDetailFormData.bankName ||
      !bankDetailFormData.ifscCode
    ) {
      setSaveBankDetailMessage("Please fill all required fields.");
      setBankDetailMessageType("error_msg");
      setTimeout(() => {
        setSaveBankDetailMessage("");
        setBankDetailMessageType("");
      }, 4000);
      return false;
    }

    return true;
  };

  // Submit Form Data
  const handleBankDetailSubmit = async () => {
    if (!validateBankDetailForm()) return;

    setIsBankDetailSaving(true);
    setSaveBankDetailMessage("");

    try {
      const updatedData = {
        ...vendorOrganisations,
        bankDetail: bankDetailFormData,
      };

      await updateDocument(vendorProfileId, updatedData);
      setBankDetailMessageType("success_msg");
      setSaveBankDetailMessage("Updated successfully!");

      setTimeout(() => {
        setIsEditing(false);
      }, 4000);
    } catch (error) {
      console.error("Error updating bank details:", error);
      setBankDetailMessageType("error_msg");
      setSaveBankDetailMessage(
        "Failed to update bank details. Please try again."
      );
    } finally {
      setIsBankDetailSaving(false);
      setTimeout(() => {
        setSaveBankDetailMessage("");
        setBankDetailMessageType("");
      }, 4000);
    }
  };
  return (
    <div className="pd-cards animate-slide-in">
      <div className="pd-heading">
        <h2>Bank Detail</h2>
        {user &&
          vendorOrganisations &&
          vendorOrganisations.isApproved != true &&
          vendorOrganisations.isActive &&
          !isEditing && (
            <div
              className="pd-edit-state"
              onClick={() => {
                setIsEditing((prev) => !prev);
              }}
            >
              <span className="material-symbols-outlined">edit</span>
              Edit
            </div>
          )}
      </div>
      <div className="pd-data">
        {!isEditing && (
          <>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/accountholder.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>A/C Holder Name</h6>
                <p>
                  {vendorOrganisations?.bankDetail?.acHolderName
                    ? vendorOrganisations.bankDetail.acHolderName
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/accountnumber.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>A/C Number</h6>
                <p>
                  {vendorOrganisations?.bankDetail?.acNumber
                    ? vendorOrganisations.bankDetail.acNumber
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/bank.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>Bank Name</h6>
                <p>
                  {vendorOrganisations?.bankDetail?.bankName
                    ? vendorOrganisations.bankDetail.bankName
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/branch.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>Branch Name</h6>
                <p>
                  {vendorOrganisations?.bankDetail?.branchName
                    ? vendorOrganisations.bankDetail.branchName
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/ifsccode.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>IFSC Code</h6>
                <p>
                  {vendorOrganisations?.bankDetail?.ifscCode
                    ? vendorOrganisations.bankDetail.ifscCode
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/ifsccode.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>UPI ID</h6>
                <p>
                  {vendorOrganisations?.bankDetail?.upiId
                    ? vendorOrganisations.bankDetail.upiId
                    : "Not provided yet"}
                </p>
              </div>
            </div>
          </>
        )}
        {isEditing && (
          <div className="col mb-4">
            <div className="row row_gap">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    A/C Holder Name
                  </label>
                  <input
                    type="text"
                    name="acHolderName"
                    value={bankDetailFormData.acHolderName}
                    onChange={handleBankDetailChange}
                    required
                    placeholder="Type A/C holder name here"
                    onKeyPress={(e) => {
                      const regex = /^[a-zA-Z\s]*$/; // Only letters and spaces allowed
                      if (!regex.test(e.key)) {
                        e.preventDefault(); // Prevent invalid input
                      }
                    }}
                    className="form-input"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    A/C Number
                  </label>
                  <input
                    type="number"
                    name="acNumber"
                    value={bankDetailFormData.acNumber}
                    onChange={handleBankDetailChange}
                    required
                    placeholder="Type A/C number here"
                    className="form-input"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    Bank Name
                  </label>
                  <input
                    type="text"
                    name="bankName"
                    value={bankDetailFormData.bankName}
                    onChange={handleBankDetailChange}
                    required
                    placeholder="Type bank name here"
                    className="form-input"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    Branch Name
                  </label>
                  <input
                    type="text"
                    name="branchName"
                    value={bankDetailFormData.branchName}
                    onChange={handleBankDetailChange}
                    required
                    placeholder="Type branch name here"
                    className="form-input"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    IFSC Code
                  </label>
                  <input
                    type="text"
                    name="ifscCode"
                    value={bankDetailFormData.ifscCode}
                    onChange={handleBankDetailChange}
                    required
                    placeholder="Type IFSC code here"
                    className="form-input"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label">UPI Id</label>
                  <input
                    type="text"
                    name="upiId"
                    value={bankDetailFormData.upiId}
                    onChange={handleBankDetailChange}
                    required
                    placeholder="Type UPI ID here"
                    className="form-input"
                  />
                </div>
              </div>
            </div>
            <div className="pd-edit-option">
              {saveBankDetailMessage && (
                <p className={`edit-msg_area ${BankDetailMessageType}`}>
                  {saveBankDetailMessage}
                </p>
              )}

              <button
                onClick={handleBankDetailCancelClick}
                disabled={isBankDetailSaving}
                className={` pd-option-btn option-btn-cancel ${
                  isBankDetailSaving ? "disabled" : ""
                }`}
              >
                Cancel
              </button>
              <button
                onClick={handleBankDetailSubmit}
                disabled={isBankDetailSaving}
                className={` pd-option-btn option-btn-save ${
                  isBankDetailSaving ? "disabled" : ""
                }`}
              >
                {isBankDetailSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorBankDetails;
